import { clstx } from '@payaca/utilities/cvaMerge';
import { ComponentPropsWithoutRef, forwardRef } from 'react';

const TooltipCore = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<'div'>>(
  (props, ref) => {
    const { className, children, ...rest } = props;

    return (
      <div
        ref={ref}
        className={clstx(
          'z-tooltip max-w-prose rounded-lg bg-gray-900 px-2.5 py-1.5 text-base font-semibold text-white shadow-sm',
          className
        )}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

export default TooltipCore;
